import { createInMemoryAtom } from '@exodus/atoms';
const createExchangeStatusAtom = () => createInMemoryAtom({ defaultValue: null });
export default createExchangeStatusAtom;
